import React from 'react';

const TableCell = ({ classes = '', children, ...rest }) => (
  <div className={`table_cell ${classes}`} {...rest}>
    {children}
  </div>
);

export default TableCell;
